<a
  appButton
  [name]="button.analyticsName || 'custom-button'"
  location="storyblok-button"
  [attr.target]="button.link.target"
  [color]="button.buttonColor || button.buttonColorOverride"
  [spacing]="button.buttonSpacing"
  [height]="button.buttonSize"
  [weight]="button.bold ? 'bold' : 'normal'"
  shape="round"
  [size]="button.textSize"
  [hasIcon]="!!button.icon && !!button.text"
  [iconButton]="!!button.icon && !button.text"
  [href]="button.link | storyblokLinkUrl"
  (click)="onClick.emit($event)"
  [rel]="button.noReferrer ? 'noopener noreferrer' : ''"
>
  @if (button.icon?.filename) {
    @if (button.iconPosition === 'left') {
      @if (button.iconHasColor) {
        <img [src]="button.icon.filename | storyblokCdn" [alt]="button.icon['alt'] || ''" />
      } @else {
        <app-svg [src]="button.icon.filename | storyblokCdn"></app-svg>
      }
    }
  }
  <span>{{ button.text }}</span>

  @if (button.icon?.filename && button.iconPosition === 'right') {
    @if (button.iconHasColor) {
      <img [src]="button.icon.filename | storyblokCdn" [alt]="button.icon['alt'] || ''" />
    } @else {
      <app-svg [src]="button.icon.filename | storyblokCdn"></app-svg>
    }
  } @else if (button.icon && button.iconPosition === 'right') {
    <!-- legacy, icon is a string -->
    <app-svg src="assets/icons/{{ button.icon }}.svg"></app-svg>
  }
</a>
